import { PortalPage } from "../../components/portal/PortalPage";
import { CapexForecastPanel } from "../../components/assets/CapexForecastPanel";

export default function ClientCapexPage() {
  return (
    <PortalPage title="Capital replacement forecast" subtitle="What's likely to need replacing at your properties over the next few years, and roughly what it will cost — so budgets never get a surprise." back={{ to: "/portal/assets", label: "All assets" }} testid="client-capex">
      <CapexForecastPanel endpoint="/client-hub/assets/capex" pdfPath="/client-hub/assets/capex.pdf" assetLink={(id) => `/portal/assets/${id}`} testid="client-capex-panel" />
      <p className="text-[11px] text-muted-foreground mt-6">Each asset's health score blends remaining design life, condition, repair frequency and time out of service. Estimates use the recorded replacement cost (or purchase cost uplifted 3% a year) and are a planning guide, not a quote.</p>
    </PortalPage>
  );
}
